import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import {useBack} from "@refinedev/core";

export const BackButton = () => {
    const back = useBack();
    return (
        <>
            <Button type="text" size="large" onClick={back} className="mr-4" icon={<ArrowLeftOutlined/>} />
        </>
    )
};